import { Guid } from "@/types"
import { AssetDisposalReason } from "./Asset"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset, { IGetNotificationAssetDto } from "./NotificationAsset"

export interface IGetNotificationAssetDisposedDto extends IGetNotification {
    notificationType: NotificationType.assetDisposed
    assetId: Guid
    disposalReason: AssetDisposalReason
    asset?: IGetNotificationAssetDto
}

export default class NotificationAssetDisposed extends Notification {
    disposalReason: AssetDisposalReason
    asset: NotificationAsset

    constructor(dto: IGetNotificationAssetDisposedDto) {
        super(dto)
        this.disposalReason = dto.disposalReason
        this.asset = new NotificationAsset({
            assetId: dto.assetId
        })
    }
}
